// extracted by mini-css-extract-plugin
export default {"color-concrete":"#F2F2F2","colorConcrete":"#F2F2F2","medium":"only screen and (min-width: 768px)","tabSwitcher":"_1tCyq","overflowContainer":"LhjH3","tabs":"_2qhpf"};